import { LoaderFunctionArgs } from "react-router-dom";
import API from "../../../utils/api";
import { ApiKeychainSchema } from "../../../utils/types";

export default function ApiKeychainDetailsPageLoader() {
  return async ({ params }: LoaderFunctionArgs) => {
    const { keychain_id } = params;
    if (!keychain_id) {
      throw new Error("No keychain ID provided");
    }

    const response = await API.get(`v1/api_keychains/details`, { id: keychain_id });
    if (!response) {
      throw new Error("Failed to fetch API keychain");
    }
    const apiKeychain = response as ApiKeychainSchema;

    return {
      apiKeychain
    };
  };
} 